<template>
    <p-dialog :visible.sync="visible" header="Update Profile Settings" :closable="true"
        @hide="$emit('toggleModal', false)" :modal="true">
        <!-- <p class="m-0">{{ getUserId ? getUserId: 'no user'}}</p> -->

        <p-inlinemessage v-if="showError" severity="error">
            <h3>Action Forbidden</h3>
            <p>{{ errorMsg }}</p>
        </p-inlinemessage>
        <p-inlinemessage v-if="showSuccess" severity="success">
            <h3>Success</h3>
            <p>{{ errorMsg }}</p>
        </p-inlinemessage>
        <div :style="themeFontColor" class="name-title">{{ firstName }} {{ lastName }}</div>

        <form class="profileForm" data-clarity-mask="true">

            <div class="p-grid">
                <div class="p-col-12 p-md-6 p-4">
                    <!-- First Name Field -->
                    <div class="p-field">
                        <label for="firstName">First Name</label><br />
                        <p-inputText id="firstName" v-model="firstName" name="firstName" placeholder="First Name"
                            class="" />
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-4">
                    <!-- Last Name Field -->
                    <div class="p-field">
                        <label for="lastName">Last Name</label><br />
                        <p-inputText id="lastName" v-model="lastName" name="lastName" placeholder="Last Name"
                            class="" />
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-4">
                    <!-- Email Field -->
                    <div class="p-field">
                        <label for="email">E-mail</label><br />
                        <p-inputText id="email" v-model="email" name="email" placeholder="joe@schmoe.com" class=""
                            readonly />
                        <p-button v-if="!googleId" @click.prevent="() => showChangeEmailModel = true" class="p-mt-2 p-mb-2">Change
                            Email</p-button>
                        <ChangeEmailModal @toggleModal="showChangeEmailModel = false"
                            :visible.sync="showChangeEmailModel" />
                    </div>
                </div>
                <!-- Referral Code Field -->
                <!-- <div class="p-col-12 p-md-6 p-4">
                    <div class="p-field">
                        <label for="referralCode">Referral Code</label><br />
                        <p-inputText id="referralCode" v-model="referralCode" name="referralCode" placeholder="No Referral Code" class=""
                            readonly />
                    </div>
                </div> -->
                <!-- Referral Link Field -->
                <!-- <div class="p-col-12 p-md-6 p-4" v-if="referralCode">
                    <div class="p-field">
                        <label for="referralLink">Referral Link</label><br />
                        <div class="p-inputgroup">
                            <p-inputText id="referralLink" v-model="referralLink" name="referralLink" placeholder="No Referral Link" class=""
                                readonly />
                            <p-button icon="pi pi-copy" @click="copyReferralLink" class="p-button-secondary" v-tooltip="'Copy Link'" />
                        </div>
                    </div>
                </div> -->
                <div class="p-col-12 p-md-6 p-4" v-if="referredBy">
                    <!-- Referred By Field -->
                    <div class="p-field">
                        <label for="referredBy">Referred By</label><br />
                        <p-inputText id="referredBy" v-model="referredBy" name="referredBy" placeholder="Referred By" class=""
                            readonly />
                    </div>
                </div>
            </div>
            <div class="p-grid" v-if="!googleId">

                <div class="p-col-12 p-md-6 p-4">
                    <!-- Old Password Field -->
                    <div class="p-field">
                        <label for="currentPassword">Old Password</label><br />
                        <p-password id="currentPassword" v-model="currentPassword" v-validate="'required'"
                            name="currentPassword" :feedback="false" />
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-4">
                    <!-- New Password Field -->
                    <div class="p-field">
                        <label for="newPassword">New Password</label><br />
                        <p-password id="newPassword" v-model="newPassword" v-validate="'required'" name="newPassword"
                            :feedback="false" />
                    </div>
                </div>
            </div>
            <div>
                <label :style="themeFontColor"> Subscription Detail</label>
                <div v-for="(item, index) in subs" :keY="index">
                    <div>
                        <div v-if="isPastDueSub">
                            <b>
                            {{ item.trial_end ? 'Your Trial Period is Expired.' : 'Your Subscription Period is Expired.' }}
                            Please <span @click="renewSubscription" style="color: blue; cursor: pointer; "><u> Pay Pending Invoice</u></span> .
                            </b>
                    </div>

                        <div v-else-if="isTrialMode">
                            <div><b>Product Name: </b>{{ item.product?.desc?.title.includes('Standard') ? 'USA Only' : 'Premium' }}</div>
                            <div><b>Product Currency: </b>{{ item.product?.desc?.currency }}</div>
                            <b> {{ trialModeText }}</b> <span v-if="false" @click="onSubscribe"
                                style="color: blue; cursor: pointer; "><u> Subscribe Now</u></span>
                        </div>
                        <div v-else>
                            <div><b>Product Name: </b>{{ item.product?.desc?.title.includes('Standard') ? 'USA Only' : 'Premium' }}</div>
                            <div><b>Product Currency: </b>{{ item.product?.desc?.currency }}</div>
                            <b>Period Start: </b> {{ formatDate(item.startPeriod) }} <b>Period End:
                            </b>{{ formatDate(item.endPeriod) }}
                        </div>

                        <span v-if="subs[0].subscription_cancel_status === true" style="color: red;">Subscription
                            already cancelled.</span>
                        <a v-else-if="!isTrialMode" @click.prevent="onSubscriptionCancel" href="/">Cancel</a>
                        <p v-if="item.product?.desc?.title.includes('Standard')&&!isTrialMode " ><router-link v-if="!subs[0].subscription_cancel_status === true" :to="{ path: `/products?isUpgrade=true` }">Upgrade Subscription to Premium</router-link></p>
                        <p v-if="!item.product?.desc?.title.includes('Standard')&&!isTrialMode " ><router-link v-if="!subs[0].subscription_cancel_status === true" :to="{ path: `/products?isDowngrade=true` }">Downgrade Subscription to USA Only</router-link></p>
                    </div>
                </div>
                <div v-if="subs.length == 0">
                    No Active subscription. <router-link :to="{ path: `/products` }">Subscribe Now</router-link>
                </div>
            </div>

            <!-- Credit Cards Management Section -->
            <p-divider align="left" type="solid" class="p-mt-4 p-mb-3">
                <b><i class="pi pi-credit-card p-mr-2"></i>Saved Credit Cards</b>
            </p-divider>

            <div class="credit-cards-section p-mb-3" :class="{ 'dark-theme': themeDarkMode }">
                <div class="p-mb-3" style="display: flex; justify-content: space-between; align-items: center;">
                    <span :style="themeFontColor" style="font-weight: 600; font-size: 1.1rem; letter-spacing: 0.5px;">Your Payment Methods</span>
                </div>

                <div v-if="loadingCards" class="p-text-center p-py-4" style="text-align: center; padding: 2rem 0;">
                    <p-progressspinner style="width:40px;height:40px" strokeWidth="4" />
                </div>

                <div v-else class="premium-cards-grid">
                    <!-- Saved Credit Cards -->
                    <div
                        v-for="card in savedCards"
                        :key="card.id"
                        class="premium-card-wrapper"
                        :class="{ 'default-card-active': card.isDefault, ['brand-' + (card.brand || '').toLowerCase().replace(/\s+/g, '')]: true }"
                    >
                        <!-- Card background glow -->
                        <div class="premium-card-bg-glow"></div>
                        
                        <!-- Card contents -->
                        <div class="premium-card-inner">
                            <div class="premium-card-header">
                                <div class="emv-chip">
                                    <svg viewBox="0 0 100 100" class="chip-svg" style="width: 32px; height: 26px;">
                                        <rect x="5" y="5" width="90" height="90" rx="12" fill="url(#chip-grad)" stroke="#d4af37" stroke-width="1.5"/>
                                        <line x1="50" y1="5" x2="50" y2="95" stroke="#d4af37" stroke-width="1"/>
                                        <line x1="5" y1="50" x2="95" y2="50" stroke="#d4af37" stroke-width="1"/>
                                        <rect x="25" y="25" width="50" height="50" rx="6" fill="none" stroke="#d4af37" stroke-width="1"/>
                                        <defs>
                                            <linearGradient id="chip-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                                                <stop offset="0%" stop-color="#ffe699" />
                                                <stop offset="50%" stop-color="#d4af37" />
                                                <stop offset="100%" stop-color="#aa7c11" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div class="card-actions-menu">
                                    <button
                                        v-if="!card.isDefault"
                                        class="premium-action-btn btn-star"
                                        v-tooltip.top="'Set Default'"
                                        @click.prevent="onSetDefaultCard(card.id)"
                                    >
                                        <i class="pi pi-star"></i>
                                    </button>
                                    <button
                                        class="premium-action-btn btn-edit"
                                        v-tooltip.top="'Edit Details'"
                                        @click.prevent="onOpenEditCard(card)"
                                    >
                                        <i class="pi pi-pencil"></i>
                                    </button>
                                    <button
                                        class="premium-action-btn btn-delete"
                                        v-tooltip.top="'Delete Card'"
                                        @click.prevent="onDeleteCard(card.id)"
                                    >
                                        <i class="pi pi-trash"></i>
                                    </button>
                                </div>
                            </div>
                            
                            <div class="premium-card-number">
                                <span class="bullet-grp">••••</span>
                                <span class="bullet-grp">••••</span>
                                <span class="bullet-grp">••••</span>
                                <span class="last-digits">{{ card.last4 }}</span>
                            </div>
                            
                            <div class="premium-card-footer">
                                <div class="card-holder-info">
                                    <span class="info-label">CARDHOLDER</span>
                                    <span class="info-value">{{ card.cardholderName || 'Valued Customer' }}</span>
                                </div>
                                <div class="card-expiry-info">
                                    <span class="info-label">EXPIRES</span>
                                    <span class="info-value">{{ card.expMonth }}/{{ String(card.expYear).slice(-2) }}</span>
                                </div>
                                <div class="card-brand-logo">
                                    <!-- Visa Logo -->
                                    <svg v-if="(card.brand || '').toLowerCase() === 'visa'" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="brand-logo-svg">
                                        <path d="M19.006 31.623l3.055-15.246h4.89l-3.056 15.246h-4.89z" fill="#FFFFFF"/>
                                        <path d="M37.382 16.793c-.767-.311-1.964-.644-3.447-.644-3.803 0-6.48 1.944-6.498 4.721-.017 2.057 1.912 3.197 3.372 3.882 1.498.704 2.003 1.157 1.996 1.787-.015.962-1.206 1.401-2.316 1.401-1.549 0-2.383-.223-3.663-.762l-.512-.244-.543 3.256c.91.405 2.589.757 4.331.774 4.045 0 6.685-1.921 6.717-4.897.025-1.632-1.012-2.873-3.238-3.9-.115-.052-.228-.1-.337-.152-1.344-.653-2.223-1.085-2.216-1.742.015-.595.698-1.205 2.21-1.205 1.258-.023 2.174.257 2.875.545l.343.155.518-3.09z" fill="#FFFFFF"/>
                                        <path d="M45.19 16.377h-3.766c-1.164 0-2.046.326-2.553 1.503l-7.234 13.743h5.138l1.026-2.738h6.279c.145.642.585 2.738.585 2.738h4.542l-4.017-15.246zm-6.233 8.791l2.062-5.508 1.189 5.508h-3.251z" fill="#FFFFFF"/>
                                        <path d="M12.981 16.377L8.212 26.8l-.512-2.531c-.889-2.92-3.626-6.096-6.7-7.662l.068.328 4.908 14.688h5.205l7.747-15.246h-5.947z" fill="#FFFFFF"/>
                                        <path d="M7.7 16.377h-.089C5.352 16.48 2.394 17.653.1 19.141l.065.311c2.464-.593 4.887-1.516 6.8-2.871l.735-.204z" fill="#F7B600"/>
                                    </svg>
                                    <!-- Mastercard Logo -->
                                    <svg v-else-if="(card.brand || '').toLowerCase() === 'mastercard'" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="brand-logo-svg">
                                        <circle cx="18" cy="24" r="14" fill="#EB001B" fill-opacity="0.9"/>
                                        <circle cx="30" cy="24" r="14" fill="#F79E1B" fill-opacity="0.9"/>
                                        <path d="M24 16.853c2.433 1.936 4 4.885 4 8.147s-1.567 6.211-4 8.147c-2.433-1.936-4-4.885-4-8.147s1.567-6.211 4-8.147z" fill="#FF5F00"/>
                                    </svg>
                                    <!-- Amex Logo -->
                                    <svg v-else-if="(card.brand || '').toLowerCase() === 'amex' || (card.brand || '').toLowerCase() === 'american express'" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="brand-logo-svg">
                                        <rect width="48" height="48" rx="6" fill="#0170B9"/>
                                        <path d="M8 32V16h4.5l2.25 5.5 2.25-5.5H21.5v16h-3.2v-8.8l-2.45 6.1h-1.6l-2.45-6.1v8.8H8zm15.5 0V16h8.8v2.8h-5.6v3.2h4.8v2.8h-4.8v3.6h5.6V32h-8.8zm10.5 0l3.8-6.4L34 16h3.6l1.9 3.5 1.9-3.5h3.6l-3.8 9.6 3.8 6.4h-3.6l-1.9-3.5-1.9 3.5H34z" fill="#FFFFFF"/>
                                    </svg>
                                    <!-- Generic Logo -->
                                    <svg v-else viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="brand-logo-svg">
                                        <rect width="40" height="28" x="4" y="10" rx="4" fill="none" stroke="#FFFFFF" stroke-width="2.5"/>
                                        <line x1="4" y1="18" x2="44" y2="18" stroke="#FFFFFF" stroke-width="2.5"/>
                                        <rect x="8" y="24" width="8" height="6" rx="1" fill="#FFFFFF"/>
                                        <rect x="20" y="24" width="12" height="4" rx="1" fill="#FFFFFF" fill-opacity="0.6"/>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <!-- Metallic Gold Default Badge -->
                        <div v-if="card.isDefault" class="premium-default-tag">
                            <span class="tag-shine"></span>
                            <i class="pi pi-star-fill"></i> DEFAULT
                        </div>
                    </div>

                    <!-- Add New Card Placeholder Card -->
                    <div class="premium-card-wrapper add-card-btn" @click.prevent="showAddCardModal = true">
                        <div class="add-card-inner">
                            <div class="add-icon-container">
                                <i class="pi pi-plus"></i>
                            </div>
                            <span class="add-title">Add New Card</span>
                            <span class="add-subtitle">Securely save a payment method</span>
                        </div>
                    </div>
                </div>
            </div>

        </form>

        <AddCardModal
            :visible.sync="showAddCardModal"
            @cardAdded="fetchCards"
            @toggleModal="showAddCardModal = false"
        />

        <EditCardModal
            :visible.sync="showEditCardModal"
            :card="selectedCardToEdit"
            @cardUpdated="fetchCards"
            @toggleModal="showEditCardModal = false"
        />

        <template #footer>
            <p-button label="OK" @click="submit" />
            <p-button class="p-button-secondary" label="Cancel" @click="$emit('toggleModal', false)" />
        </template>
    </p-dialog>
</template>


<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import {
    deleteSavedCard,
    deleteSubscription,
    getSavedCards,
    getUserData,
    renewSubscription,
    setDefaultSavedCard,
    updateUserProfile,
} from '../../../services/user'
import { identifyUser } from '../../../utils/clarity'
import { IndicatorSettingsDefaults } from '../../settingsHelper/GeneralSettingsDefaults'
import AddCardModal from './AddCardModal.vue'
import ChangeEmailModal from './ChangeEmailModal.vue'
import EditCardModal from './EditCardModal.vue'

const notificationTimeout = 5000
export default {
    name: 'ProfileSettings',
    components: {
        ChangeEmailModal,
        AddCardModal,
        EditCardModal,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
    },
    async mounted() {
        const token = localStorage.getItem('state')
        if (token) {

            const data = await getUserData();
            if (data.status === 'active') {
            } else if (data.status === 'inactive') {
                //this.$router.push('/products')
            }
            else {
                // this.$router.push('/login')
            }
            this.firstName = data.firstName
            this.googleId = data.googleId ? true : false
            this.userId = data.id
            this.lastName = data.lastName
            this.email = data.email
            this.referralCode = data.referralCode || ''
            if (this.referralCode) {
                this.referralLink = window.location.origin + '/#/login?ref=' + this.referralCode
            }
            this.referredBy = data.referredBy || ''
            this.subscription = data.subscription || 'yearly'
            this.currentPassword = ''
            if (data && data.userData) {
                let newDataSet = JSON.parse(JSON.stringify(data.userData))
                if (!("additional" in newDataSet?.indicatorSettings)) {
                    newDataSet.indicatorSettings['additional'] = IndicatorSettingsDefaults?.indicatorSettings?.additional
                }
                await this.updateProfileData(newDataSet)
                this.$store.commit('SET_USER_EMAIL', this.email)
            }
            else {
                this.$store.commit('SET_APP_TOUR', false)
            }
            if (data && data.id) {
                this.$store.commit('SET_USER_ID', data.id)
                identifyUser(data.id)
                this.getUserWatches()
                this.getUserScanList(true)
                this.getSavedLayouts()
                this.getSPXDataFunc()
            }

            if (data && data.userSettings && data.userSettings.chartSettings) {
                this.$store.commit('SET_CHART_SETTINGS', data.userSettings.chartSettings)

                this.$store.commit(
                    'SET_CHART_DEFAULT_SETTINGS',
                    data.userSettings.chartSettings
                )
                this.$store.commit('UPDATE_CHART_STATE', new Date().getTime())
            }

            if(data && data?.userData?.trailingStopToolSettings){
                this.$store.commit('SET_TRAIL_STOP_TOOLS_DEFAULT_VALUES',data.userData.trailingStopToolSettings)
            }
            this.fetchCards()
        }

    },
    methods: {
        ...mapActions(['getUserWatches', 'getUserScanList', 'updateProfileData', 'getSavedLayouts', 'getSPXDataFunc', 'setProductPageTrial']),
        async fetchCards() {
            this.loadingCards = true
            try {
                const res = await getSavedCards()
                if (res && res.success) {
                    this.savedCards = res.cards || []
                } else {
                    this.savedCards = []
                }
            } catch (e) {
                console.error('Error fetching cards:', e)
                this.savedCards = []
            } finally {
                this.loadingCards = false
            }
        },
        async onSetDefaultCard(cardId) {
            try {
                const res = await setDefaultSavedCard(cardId)
                if (res && res.success) {
                    this.setSuccess('Default payment method updated')
                    await this.fetchCards()
                } else {
                    this.setError(res?.message || 'Failed to update default card')
                }
            } catch (e) {
                this.setError('Failed to set default card')
            }
        },
        onOpenEditCard(card) {
            this.selectedCardToEdit = card
            this.showEditCardModal = true
        },
        async onDeleteCard(cardId) {
            if (confirm('Are you sure you want to delete this credit card?')) {
                try {
                    const res = await deleteSavedCard(cardId)
                    if (res && res.success) {
                        this.setSuccess('Credit card deleted')
                        await this.fetchCards()
                    } else {
                        this.setError(res?.message || 'Failed to delete card')
                    }
                } catch (e) {
                    this.setError('Failed to delete credit card')
                }
            }
        },
        onClose() {
            this.$emit('change', !open)
        },
        setError(msg) {
            this.errorMsg = msg
            this.showError = true
            this.showSuccess = false
            setTimeout(() => {
                this.showError = false
                this.showSuccess = false
                this.errorMsg = ""
            }, notificationTimeout)
        },
        setSuccess(msg) {
            this.currentPassword = ""
            this.newPassword = ""
            this.errorMsg = msg
            this.showError = false
            this.showSuccess = true
            setTimeout(() => {
                this.showError = false
                this.showSuccess = false
                this.errorMsg = ""
            }, notificationTimeout)
        },
        submit() {
            let updateProfile = {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                userId: this.userId,
                currentPassword: this.currentPassword,
                newPassword: this.newPassword,
            }
            updateUserProfile(updateProfile).then(d => {
                if (d?.status) {
                    this.setSuccess(d.msg)
                } else {
                    this.setError(d?.msg || 'Failed to update profile')
                }
            }).catch(e => {
                this.setError('Invalid Request')
            })
        },
        formatDate(val) {
            return moment(val).format("DD/MM/YYYY HH:mm")
        },
        async onClickTrialActivate() {
            this.$router.push("/products")
        },
        async onSubscriptionCancel() {
            if (confirm('Are you sure, you want to cancel the subscription?')) {
                const payload = this.subs[0].subscriptionId
                const cancel_response = await deleteSubscription(payload)
                // this.$router.push('/products')
                await this.$store.dispatch('user/retrieveUserSubscriptionStatus')
                this.$emit('change', !open);

                // localStorage.removeItem('state')
            }

            // location.reload()
            // const data = await fetchAllSubscriptions()
            // this.$store.commit('user/setSubscriptionList', data.subscription)
        },
    async renewSubscription() {
            const payload = this.subs[0].subscriptionId;
            const renew_response = await renewSubscription(payload);
            
            // Redirect the user to the Stripe Hosted Invoice page
            if (renew_response && renew_response.subscription && renew_response.subscription.renewUrl) {
                window.location.href = renew_response.subscription.renewUrl;
            } else {
                this.setError("Unable to process renewal. Please try again.");
            }
        },
        async onSubscribe() {
            if (this.isTrialMode) {
                this.setProductPageTrial(true);
            }
            this.$router.push('/products');
        },
        copyReferralLink() {
            if (this.referralLink) {
                navigator.clipboard.writeText(this.referralLink).then(() => {
                    this.setSuccess('Referral link copied to clipboard');
                }).catch(() => {
                    this.setError('Failed to copy referral link');
                });
            }
        },
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            userId: '',
            referralCode: '',
            referralLink: '',
            referredBy: '',
            currentPassword: '',
            newPassword: '',
            googleId:false,
            subscription: '',
            isTrial: false,
            showError: false,
            showSuccess: false,
            showChangeEmailModel: false,
            errorMsg: "",
            subs: [],
            savedCards: [],
            loadingCards: false,
            showAddCardModal: false,
            showEditCardModal: false,
            selectedCardToEdit: null,
        }
    },
    computed: {
        ...mapGetters(['themeFontColor', 'themeDarkMode', 'themeSecondaryColor', 'getUserId']),
        subscriptions() {
            return this.$store.state.user.subscriptionList
        },
        isTrialMode() {
            return this.$store.state.user.subscriptionStatus === 'trialing'
        },
        isPastDueSub() {
            return this.$store.state.user.subscriptionStatus === 'past_due'
        },
        trialModeText() {
            return this.isTrialMode
                ? ' Trial ends in ' + this.$store.state.user.trialEndsIn + ' day(s)'
                : ''
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.fetchCards()
            }
        },
        subscriptions() {
            this.subs = this.subscriptions[0].message === "Subscription is not found" ? [] : this.subscriptions
        },
    },

    beforeUpdate() {
    }

}
</script>

<style>
.profile-font {
    font-size: 14px;
}

.name-title {
    font-size: medium;
    margin: 0.6rem 0;
}

/* Premium Cards Grid */
.premium-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 12px;
}

/* Base Card Wrapper */
.premium-card-wrapper {
  position: relative;
  height: 155px;
  border-radius: 14px;
  padding: 16px;
  color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: linear-gradient(135deg, #3a3d40 0%, #181a1b 100%); /* obsidian default */
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.premium-card-wrapper:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.18);
  border-color: rgba(255, 255, 255, 0.2);
}

/* Card Brand specific backgrounds */
.premium-card-wrapper.brand-visa {
  background: linear-gradient(135deg, #1e3c72 0%, #122544 60%, #0d1b33 100%);
}

.premium-card-wrapper.brand-mastercard {
  background: linear-gradient(135deg, #4f1718 0%, #290809 60%, #150203 100%);
}

.premium-card-wrapper.brand-amex,
.premium-card-wrapper.brand-americanexpress {
  background: linear-gradient(135deg, #0e5e95 0%, #0b3d61 60%, #052237 100%);
}

/* Default card styling (Gold accent) */
.premium-card-wrapper.default-card-active {
  box-shadow: 0 0 0 1px #d4af37, 0 8px 20px rgba(212, 175, 55, 0.12);
  border-color: rgba(212, 175, 55, 0.4);
}

.premium-card-wrapper.default-card-active:hover {
  box-shadow: 0 0 0 2px #d4af37, 0 12px 30px rgba(212, 175, 55, 0.22);
}

/* Card Glow Effect */
.premium-card-bg-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.06) 0%, transparent 70%);
  pointer-events: none;
  transform: rotate(30deg);
  transition: transform 0.5s ease;
}

.premium-card-wrapper:hover .premium-card-bg-glow {
  transform: rotate(45deg) translate(5%, 5%);
}

/* Card Inner Content Layout */
.premium-card-inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Card Header */
.premium-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* EMV Chip */
.emv-chip {
  opacity: 0.85;
}

/* Brand Logo */
.brand-logo-svg {
  width: 42px;
  height: 26px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

/* Monospace Card Number */
.premium-card-number {
  font-family: 'SF Mono', SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 1.1rem;
  letter-spacing: 2px;
  word-spacing: 4px;
  margin: 10px 0;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
}

.premium-card-number .bullet-grp {
  margin-right: 12px;
  font-size: 1.2rem;
  vertical-align: middle;
}

.premium-card-number .last-digits {
  font-weight: 600;
}

/* Card Footer */
.premium-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.card-holder-info, .card-expiry-info {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 0.55rem;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 2px;
}

.info-value {
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Default Tag styling (Gold Metallic) */
.premium-default-tag {
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(135deg, #d4af37 0%, #aa7c11 100%);
  color: #000000;
  font-size: 0.6rem;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  gap: 3px;
  z-index: 2;
  overflow: hidden;
}

.premium-default-tag i {
  font-size: 0.6rem;
}

.tag-shine {
  position: absolute;
  top: 0;
  left: -50%;
  width: 30%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transform: skewX(-20deg);
  animation: shine-animation 4s infinite linear;
}

@keyframes shine-animation {
  0% { left: -50%; }
  10% { left: 120%; }
  100% { left: 120%; }
}

/* Translucent Action Buttons Menu */
.card-actions-menu {
  display: flex;
  gap: 6px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 4px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  opacity: 0;
  transform: translateY(-5px);
  transition: all 0.25s ease;
}

.premium-card-wrapper:hover .card-actions-menu {
  opacity: 1;
  transform: translateY(0);
}

.premium-action-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.75rem;
}

.premium-action-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  transform: scale(1.1);
}

.premium-action-btn.btn-delete:hover {
  background: rgba(239, 68, 68, 0.25);
  color: #ef4444;
}

.premium-action-btn.btn-star:hover {
  background: rgba(212, 175, 55, 0.25);
  color: #ffe066;
}

/* Add Card Placeholder Button Style */
.premium-card-wrapper.add-card-btn {
  background: transparent;
  border: 2px dashed rgba(108, 117, 125, 0.3);
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: none;
}

.premium-card-wrapper.add-card-btn:hover {
  border-color: #2196f3;
  color: #2196f3;
  background: rgba(33, 150, 243, 0.02);
}

/* Adjust when dark mode is enabled on page */
.dark-theme .premium-card-wrapper.add-card-btn {
  border-color: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.55);
}

.dark-theme .premium-card-wrapper.add-card-btn:hover {
  border-color: #2196f3;
  color: #2196f3;
  background: rgba(33, 150, 243, 0.05);
}

.add-card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.add-icon-container {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(108, 117, 125, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.premium-card-wrapper.add-card-btn:hover .add-icon-container {
  background: rgba(33, 150, 243, 0.15);
  transform: scale(1.1);
}

.add-title {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 2px;
}

.add-subtitle {
  font-size: 0.7rem;
  opacity: 0.75;
}
</style>